(function () {
  if (window.__rcCarouselInit) return;
  window.__rcCarouselInit = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = new WeakMap();

  function parseCount(str) {
    if (!str) return null;
    str = String(str).trim().toUpperCase().replace(',', '.');
    var match = str.match(/^([\d.]+)\s*(K|M)?$/);
    if (!match) return null;
    var num = parseFloat(match[1]);
    if (isNaN(num)) return null;
    if (match[2] === 'K') num *= 1000;
    if (match[2] === 'M') num *= 1000000;
    return Math.round(num);
  }

  function formatCount(num) {
    if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(num);
  }

  function spawnHeart(layer, color) {
    if (!layer) return;
    var heart = document.createElement('span');
    heart.className = 'rc-heart-fx';
    heart.innerHTML = '<svg width="' + (14 + Math.random() * 10) + '" height="' + (14 + Math.random() * 10) + '" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.6-4.6-10.2-9.1C.1 8.6 1.2 5 4.8 4 7.2 3.3 9.2 4.2 12 7c2.8-2.8 4.8-3.7 7.2-3 3.6 1 4.7 4.6 2.8 7.9C19.6 16.4 12 21 12 21z"/></svg>';
    var drift = (Math.random() * 60 - 30).toFixed(0) + 'px';
    var duration = (2600 + Math.random() * 1800).toFixed(0) + 'ms';
    heart.style.setProperty('--rc-drift', drift);
    heart.style.right = (10 + Math.random() * 20) + 'px';
    heart.style.animationDuration = duration;
    layer.appendChild(heart);
    window.setTimeout(function () {
      if (heart.parentNode) heart.parentNode.removeChild(heart);
    }, 4600);
  }

  function burst(layer, count) {
    if (prefersReducedMotion) return;
    for (var i = 0; i < count; i++) {
      (function (delay) {
        window.setTimeout(function () { spawnHeart(layer); }, delay);
      })(i * 90);
    }
  }

  function initInstance(root) {
    if (instances.has(root)) return;

    var track = root.querySelector('[data-rc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rc-slide]'));
    var prevBtn = root.querySelector('[data-rc-prev]');
    var nextBtn = root.querySelector('[data-rc-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rc-dot]'));
    var heartsEnabled = root.getAttribute('data-hearts-enabled') === 'true' && !prefersReducedMotion;
    var autoplayEnabled = root.getAttribute('data-autoplay') !== 'false';
    var frequency = parseInt(root.getAttribute('data-hearts-frequency'), 10) || 5;
    var ambientInterval = Math.max(250, 1700 - frequency * 140);

    var state = {
      timers: [],
      observers: [],
      isDragging: false
    };

    function slideStep() {
      if (!slides.length) return 0;
      var rect = slides[0].getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return rect.width + gap;
    }

    function updateArrows() {
      if (!track) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function updateDots() {
      if (!dots.length) return;
      var step = slideStep();
      if (!step) return;
      var index = Math.round(track.scrollLeft / step);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
        track.scrollTo({ left: index * slideStep(), behavior: 'smooth' });
      });
    });

    if (track) {
      var scrollRaf = null;
      track.addEventListener('scroll', function () {
        if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
        scrollRaf = window.requestAnimationFrame(function () {
          updateArrows();
          updateDots();
        });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { track.scrollBy({ left: slideStep(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { track.scrollBy({ left: -slideStep(), behavior: 'smooth' }); }
      });

      var dragStartX = 0;
      var dragStartScroll = 0;
      var pointerDown = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        pointerDown = true;
        state.isDragging = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!pointerDown) return;
        var delta = e.clientX - dragStartX;
        if (Math.abs(delta) > 4) state.isDragging = true;
        track.scrollLeft = dragStartScroll - delta;
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (evt) {
        track.addEventListener(evt, function () { pointerDown = false; });
      });
    }

    slides.forEach(function (slide, slideIndex) {
      var video = slide.querySelector('[data-rc-native-video]');
      var heartsLayer = slide.querySelector('[data-rc-hearts]');
      var muteBtn = slide.querySelector('[data-rc-mute]');
      var likeBtn = slide.querySelector('[data-rc-like]');
      var likeCountEl = slide.querySelector('[data-rc-like-count]');
      var playToggle = slide.querySelector('[data-rc-play-toggle]');
      var embedPoster = slide.querySelector('[data-rc-embed-poster]');
      var ambientTimer = null;

      if (embedPoster) {
        embedPoster.addEventListener('click', function () {
          embedPoster.style.display = 'none';
        });
      }

      if (muteBtn && video) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        });
      }

      if (playToggle && video) {
        playToggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play();
            playToggle.classList.add('is-hidden');
          } else {
            video.pause();
            playToggle.classList.remove('is-hidden');
          }
        });
      }

      function baseLikeCount() {
        var parsed = parseCount(likeCountEl ? likeCountEl.textContent : null);
        return parsed === null ? null : parsed;
      }
      var likeTotal = baseLikeCount();

      if (likeBtn) {
        likeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          likeBtn.classList.add('is-liked');
          window.setTimeout(function () { likeBtn.classList.remove('is-liked'); }, 260);
          if (likeTotal !== null && likeCountEl) {
            likeTotal += Math.floor(Math.random() * 3) + 1;
            likeCountEl.textContent = formatCount(likeTotal);
          }
          burst(heartsLayer, 6);
        });
      }

      if (heartsLayer) {
        heartsLayer.addEventListener('click', function () {
          burst(heartsLayer, 5);
        });
      }

      function startAmbient() {
        if (!heartsEnabled || ambientTimer) return;
        ambientTimer = window.setInterval(function () {
          spawnHeart(heartsLayer);
        }, ambientInterval + Math.random() * 400);
      }
      function stopAmbient() {
        if (ambientTimer) {
          window.clearInterval(ambientTimer);
          ambientTimer = null;
        }
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              startAmbient();
              if (video && autoplayEnabled) {
                var playPromise = video.play();
                if (playPromise && playPromise.catch) playPromise.catch(function () {});
                if (playToggle) playToggle.classList.add('is-hidden');
              }
            } else {
              stopAmbient();
              if (video) video.pause();
            }
          });
        }, { threshold: 0.55 });
        io.observe(slide);
        state.observers.push(io);
      } else if (video && autoplayEnabled) {
        video.play().catch(function () {});
        startAmbient();
      }
    });

    updateArrows();
    updateDots();
    instances.set(root, state);
  }

  function destroyInstance(root) {
    var state = instances.get(root);
    if (!state) return;
    state.timers.forEach(window.clearInterval);
    state.observers.forEach(function (io) { io.disconnect(); });
    instances.delete(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.rc-root');
    roots.forEach ? roots.forEach(initInstance) : Array.prototype.forEach.call(roots, initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('.rc-root') : null;
    if (root) destroyInstance(root);
  });
})();